module.exports = require('./bundle-url').getBundleURL() + "plockledemo3.2e5e899a.jpg"